import Vue from 'vue'
import Component from 'vue-class-component'
import VideoTab from '../videoTab/videoTab'
import ChooseStyle from '../chooseStyle/chooseStyle.vue'
import PopupContainer from "../popupContainer/popupContainer.vue"
import ChooseSpeed from '../chooseSpeed/chooseSpeed.vue'
import PageState from '../../store/state'
import moduleStore from '../../store/videoEditor'
import SearchSpeaker from '@/views/searchSpeaker/searchSpeaker'
import SpeakerCards from '@/views/searchSpeaker/components/speakerCards/speakerCards'
import { judgeDeviceType } from '@/utils/device'
import { Prop } from 'vue-property-decorator'
import { debouncedSaveArticle } from '../../utils/utils'

@Component({
  props : {
    visible: {
      type: Boolean,
      default: false
    },
    speakerInfo: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    visible(val) {
      if (val && this.speakerInfo.speakerName) {
        this.currentSpeaker = {
          name: this.speakerInfo.speakerName.split('|')[0]
        }
        this.currSpeed = this.speakerInfo.speed
        this.currStyle = this.speakerInfo.style
        this._getSpeakerList('', {keyword: this.speakerInfo.speakerName.split('|')[0], pageNum: 1, pageSize: 100})
      }
      this.showSpeakerPopup = val
      if (!val) {
        this.$bus.$emit(this.$EventBusKey.REQUEST_SAVE_ARTICLE)
        this.$bus.$emit(this.$EventBusKey.SAVE_DATA)
      }
    },
  },
  components: {
    VideoTab,
    ChooseStyle,
    PopupContainer,
    ChooseSpeed,
    SearchSpeaker,
    SpeakerCards
  }
})
@moduleStore.initVuex({
  mutationNames:moduleStore.mutationNames,
  actionNames:moduleStore.actionNames
})
export default class SpeakerPopup extends Vue {
  @Prop({default: false})
  visible
  @Prop({default: () => {}})
  speakerInfo:any
  speakerCardInfo: any
  state = new PageState()
  showSpeakerPopup = false
  tabList = [
    {
      id: 0,
      name: '配音设置'
    },
    {
      id: 1,
      name: '收藏发音人'
    }
  ]
  // 当前tabId
  activeTabId = 0
  // 当前风格
  currStyle = '默认'
  // 当前语速
  currSpeed = '1.0'
  // 是否显示语速选择
  showSpeed = false
  emotionListMap = {}
  speakerEmotionCacheVOList = []
  allSpeakerEmotionCacheVOList = []
  showSpeakerPage = false
  speakerResults = [] // 根据条件筛选出来的发音人
  currentSpeaker:any = {}
  isApp = judgeDeviceType.isAPP
  mounted() {
    console.log('发音人列表', this.$store)
    // this._getSpeakerList('', {key})
    this._getSpeakerEmotionList()
    window.addEventListener('storage', this.storageEvent);
  }
  destroy() {
    window.removeEventListener('storage', this.storageEvent);
  }
  // 监听localStorage变化，设置currSpeaker
  storageEvent(event: StorageEvent) {
    const { key, newValue } = event;
    if(key === 'currSpeaker' && newValue) {
      this.selectSpeaker(JSON.parse(newValue));
      localStorage.removeItem('currSpeaker');
    }
  }

  /**
   * 切换tabid
   * @param tabId
   */
  changeTab(tabId) {
    this.activeTabId = tabId
    if (tabId === 1) {
      this._getSpeakerList('favorite')
    }
  }
  /**
   * 选择语速
   * @param speed
   */
  chooseSpeed(speed) {
    this.currSpeed = speed
    debouncedSaveArticle(this)
    let obj = {
      ...this.speakerInfo ,
      speed: this.currSpeed,
      style: this.currStyle
    }
    if (this.speakerInfo.speakerName) {
      obj.name = this.speakerInfo.speakerName
    }
    this.$emit('change-speaker', obj)
  }
  /**
   * 关闭弹窗
   */
  closePopup() {
    this.showSpeakerPopup = false
    this.$emit('close')
  }
  /**
   * 确认
   */
  confirmSpeaker() {
    this.showSpeakerPopup = false;
    this.$refs.chooseStyleRef && (this.$refs.chooseStyleRef as any).stopPlay();
    this.$refs.speakerCardsRef && (this.$refs.speakerCardsRef as any).cancelListen();
    this.$emit("changeSpeaker", this.currentSpeaker);
    this.$emit('close');
  }
  /**
   * 显示语速
   */
  handleSpeedPopup() {
    this.showSpeed = true
  }
  closeSpeedPopup() {
    this.showSpeed = false
  }
  /**
   * 选择情绪
   * @param emtotion
   */
  selectEmotion(value) {
    console.log('selectEmotion', value)
    let selectedName = value.name.split("|")[1];
    this.currStyle = selectedName || '默认'
    value.name = value.name.split("|")[0]
    this.currentSpeaker = {...this.currentSpeaker, ...value}
    debouncedSaveArticle(this)
    this.$emit('change-speaker', {
      ...value,
      speed: this.currSpeed,
      style: this.currStyle
    })
  }
  /**
   * 显示发音人面板
   */
  showSpeaker() {
    // this.showSpeakerPage = true
    const linkUrl = window.location.origin + '/#/searchSpeaker?speakerId=' + this.currentSpeaker?.speakerId + '&open=true'
    if (this.isApp) {
      let switchWebviewUrl = (<any>window).switchWebviewUrl;
      switchWebviewUrl.postMessage(linkUrl)
    } else {
      this.$navigateTo({
        url: '/pages/webview/webview?url=' + encodeURIComponent(linkUrl),
      })
    }
  }
  /**
   * 选择发音人
   * @param speakerInfo
   */
  selectSpeaker(speakerInfo) {
    this.showSpeakerPage = false
    this.currentSpeaker = speakerInfo
    this.speakerEmotionCacheVOList = speakerInfo.speakerEmotionCacheVOList
    this._getCurrentSpeakerEmotionList()
    this.$store.state.currSpeaker = speakerInfo
    console.log('selectSpeaker', speakerInfo)
    debouncedSaveArticle(this)
  }
  /**
   * 选中当前发音人
   * @param speaker
   */
  setCurrentSpeaker(speaker) {
    this.speakerCardInfo = speaker;
    this.cancelListen()
  }
  // 用收藏发音人配音
  useSpeaker() {
    this.cancelListen();
    this.selectSpeaker(this.speakerCardInfo);
    this.changeTab(0);
  }
  /**
   * 收藏/取消发音人
   * @param speaker 
   */
  changeFavourite(speaker) {
    const index = this.speakerResults.findIndex(item => item.speakerId === speaker.speakerId)
    if (index !== -1) {
      this.speakerResults.splice(index, 1);
      (this.$refs.searchSpeakerRef as any).subSubType()
    }
  }
  cancelListen(){
    console.log('---寻找发音人页面取消试听');
    if(this.$refs.speakerCardsRef){
      let speakerCardsRef = this.$refs.speakerCardsRef as any
      speakerCardsRef.cancelListen();
    }
  }
  // 获取发音人列表
  _getSpeakerList(type, _params?:any) {
    let params = {
      pageSize: 100,
      pageNum: 1,
    }
    if (type === 'favorite') {
      params['favourite'] = true
    } else {
      params = {...params, ..._params}
    }
    this.$http('getSpeakerSearchList', params).then(res => {
      if (res.code == 200) {
        let list = res.data.results
        console.log('getSpeakerSearchList', list)
        if (type) {
          if(list.length>0){
            list = list.map((item,index)=>{
              return {
                ...item,
                defaultSpeaker:item.speakerEmotionCacheVOList[0]
              }
            })
          }
          this.speakerResults = list
        } else {
          console.log('speakerInfo', this.speakerInfo)
          const _speakerInfo = list.find(item => item.name === this.speakerInfo.speakerName.split('|')[0])
          const currentList = []
          _speakerInfo.speakerEmotionCacheVOList.forEach(item => {
            currentList.push({
              ..._speakerInfo,
              ...item
            })
          })
          this.currentSpeaker = currentList.find(item => item.speaker === this.speakerInfo.speaker)
          if (!this.currentSpeaker) {
            this.currentSpeaker = currentList[0]
          }
          // this.currentSpeaker
          this._getSpeakerEmotionList('init')
        }
        
        console.log('speakerResults', res.data)
      }
    })
  }
  // 获取发音人情感列表
  _getSpeakerEmotionList(type?: string) {
    return new Promise((resolve,reject)=>{
        let vm = this
        return this.$http('getSpeakerEmotionList', {}).then((res) => {
          if (res.code == 200) {
            this.$store.state.emotionListMap = (res.data || []).reduce(
              (target: any, item: any) => {
                target[item.emotion] = {imageUrl:item.imageUrl,emotionName:item.emotionName}
                return target
              },
              {}
            )
            this.speakerEmotionCacheVOList = this.currentSpeaker.speakerEmotionCacheVOList
            this.allSpeakerEmotionCacheVOList = res.data
            this._getCurrentSpeakerEmotionList(type)
            resolve(res);
          } else {
            // this
            reject(res);
          }
        }).catch(err=>{
            console.log(err);
            reject(err)
        })
    })
  }
  _getCurrentSpeakerEmotionList(type?: string) {
    if (!this.speakerEmotionCacheVOList) return
    this.speakerEmotionCacheVOList = this.speakerEmotionCacheVOList.map(item => {
      const emotion = item.speaker.split('@')[1]
      let emotionInfo
      if (emotion) {
        emotionInfo = this.allSpeakerEmotionCacheVOList.filter(_item => _item.emotion == emotion)
        item.moodName = emotionInfo[0]&&emotionInfo[0].emotionName ||'默认'
      } else {
        emotionInfo = this.allSpeakerEmotionCacheVOList.filter(_item => _item.emotion.trim() == 'default2')
        item.moodName = '默认'
      }
      if (emotionInfo && emotionInfo.length > 0) {
        item.moodImg = emotionInfo[0]&&emotionInfo[0].imageUrl||item.speaker.headerImage
      }
      return item
    })
    if (type === 'init') return
    const current = this.speakerEmotionCacheVOList.find(item => item.moodName === '默认')
    this.currentSpeaker = {...this.currentSpeaker, ...current}
    this.currentSpeaker.name = this.currentSpeaker.name.split('|')[0]
    this.$emit('change-speaker', {
      ...this.currentSpeaker,
      speed: this.currSpeed,
      style: this.currStyle
    })
    // this.currentSpeaker = {...this.currentSpeaker, ...item}
  }

}